import { render, staticRenderFns } from "./grossing-touch-voice-recorder-card.vue?vue&type=template&id=134efb5a&scoped=true&"
import script from "./grossing-touch-voice-recorder-card.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-voice-recorder-card.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-voice-recorder-card.scss?vue&type=style&index=0&id=134efb5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134efb5a",
  null
  
)

export default component.exports